import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { BTN_ACCENT_SM } from '../lib/buttonStyles';

/**
 * «Готово: <название>» — запись доделана без вкладки и уже лежит в Истории.
 *
 * Макет «Бумага» (тост после возврата): заголовок «Готово: …», строка
 * «Расшифровка в Истории», кнопка «Открыть». Показывается один раз на задание:
 * закрытие и открытие отмечают его просмотренным на сервере (`POST /jobs/{id}/seen`),
 * поэтому второй вкладке или F5 показывать уже нечего.
 *
 * Упавшее без человека задание идёт тем же тостом с причиной — иначе о том,
 * что запись не доехала, узнать негде.
 */

const AUTO_HIDE_MS = 15000;

export default function JobDoneToast({ job, onOpen, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, AUTO_HIDE_MS);
    return () => clearTimeout(t);
  }, [onClose, job?.id]);

  if (!job) return null;
  const failed = job.status === 'failed';

  return (
    <div className="fixed bottom-6 right-6 z-40 w-[340px] p-5"
         role="status" aria-live="polite"
         style={{ background: '#fff', borderRadius: 18, boxShadow: '0 12px 32px rgba(0,0,0,.1)' }}>
      <button onClick={onClose} aria-label="Закрыть"
              className="absolute top-3 right-3 p-1" style={{ color: '#a0a0a0' }}>
        <X className="h-3.5 w-3.5" />
      </button>
      <div className="text-[14px] font-semibold text-black pr-5">
        {failed ? `Не получилось: ${job.title}` : `Готово: ${job.title}`}
      </div>
      <div className="mt-1.5 text-[13px] leading-relaxed" style={{ color: '#5a5a5a' }}>
        {failed ? (job.last_error || 'Запись не распознана') : 'Расшифровка в Истории'}
      </div>
      {!failed && job.item_id && (
        <button onClick={onOpen}
                className={`mt-4 ${BTN_ACCENT_SM}`}>
          Открыть
        </button>
      )}
    </div>
  );
}
